import { ChatIcon } from '@rsos/assets/icons';
import { Box, Button, Text } from '@rsos/base-components';
import { HalfWidthContent } from '../tabs/OverviewTab/OverviewTab.styles';

/**
 * GMR air ambulance card for the overview tab.
 * @param {Function} onClick - Callback function when the card is clicked
 */
const OverviewAirAmbulanceCard = ({ onClick = () => {} }) => {
  return (
    <HalfWidthContent
      backgroundColor="background"
      data-name="overview-air-ambulance-card"
    >
      <Box horizontal marginBottom="4px">
        <ChatIcon color="primaryText" height={12} width={12} />
        <Text
          color="primaryText"
          data-name="overview-air-ambulance-card-title"
          fontWeight="bold"
          lineHeight="1"
          marginLeft="4px"
          size="normal"
        >
          Air Ambulance
        </Text>
      </Box>
      <Text
        color="secondaryText"
        data-name="overview-air-ambulance-card-subtitle"
        lineHeight="1"
        marginBottom="8px"
        size="xsmall"
      >
        Local Air Providers
      </Text>
      <Text
        color="primaryText"
        data-name="overview-air-ambulance-card-description"
        marginBottom="16px"
        size="normal"
      >
        Request emergency helicopter services for severe medical emergencies.
      </Text>
      <Button
        btnType="tertiary"
        dataName="overview-air-ambulance-card-button"
        grow
        noMargin
        onClick={onClick}
      >
        <Text color="secondaryText" lineHeight="1" size="normal">
          Request
        </Text>
      </Button>
    </HalfWidthContent>
  );
};

export default OverviewAirAmbulanceCard;
